import { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { fetchFacturesAchat } from '../../../api/factureAchatApi'; // Chemin corrigé

const ListeFacturesAchat = () => {
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadFactures = async () => {
      try {
        const data = await fetchFacturesAchat();
        setFactures(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadFactures();
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'date', headerName: 'Date', width: 120, valueFormatter: (params) => new Date(params.value).toLocaleDateString() },
    { field: 'fournisseur', headerName: 'Fournisseur', width: 200 },
    { field: 'montant', headerName: 'Montant (€)', width: 120 },
    { field: 'statut', headerName: 'Statut', width: 120 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={`/factures-achat/${params.row.id}`}
        >
          Détails
        </Button>
      ),
    },
  ];

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Erreur : {error}</div>;

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <Typography variant="h4" gutterBottom>
        Liste des factures d'achat
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/factures-achat/ajouter"
        sx={{ mb: 2 }}
      >
        Ajouter une facture
      </Button>
      <DataGrid
        rows={factures}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        autoHeight
      />
    </Box>
  );
};

export default ListeFacturesAchat;
